import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import { getChannelName, getChannelProvider } from 'utils/channelsUtils'

/**
 * Prover name for channel
 * @param {object} props
 * @param {string} [props.provider] If this channels property exists it is ignored
 * @param {[{connectionType: string, channel: string}]} [props.channels] If provider is specified, channels is ignored
 * @param {boolean} [props.info]
 * @param {string} [props.className]
 */
const ProviderNameText = (props) => {
  const { channels, info, className, channel } = props
  const channelName = channel || getChannelName(channels)
  const provider = getChannelProvider(channels)

  let aClassName = []
  if (info) aClassName.push("provider-text--info")
  if (className) aClassName.push(className)
  if (provider === 'tyntec') aClassName.push('tyntec_wa')

  return (
    <span
      className={`provider-text ${channelName} ${aClassName.join(' ')}`}
    >
      {I18n.t(`channels_${channelName}`)}
    </span>
  )
}

export default ProviderNameText
